import _ from 'lodash';

// ค่าสมัครสอบต่อวิชา (บาท) — อ้างใน ALevelSummary / TGATTPATSummary
export const EXAM_UNIT_PRICE = { alevel: 100, tgattpat: 140 };

// ยอดที่นับว่าชำระแล้วจากประวัติ confirmation:
// order จ่ายครบ = total_amount, order ค้างจ่าย = ส่วนที่จ่ายไปแล้ว (total - ยอดค้าง)
const paidOf = ({ order_status, payment_amount, total_amount }) =>
  order_status === 'paid' ? total_amount : total_amount - payment_amount;

export const getALevelPaymentSummary = ({ confirmations = [], subjectCount = 0 }) => {
  const paidAmount = _.sumBy(confirmations, paidOf);
  return {
    paidAmount,
    paymentAmount: EXAM_UNIT_PRICE.alevel * subjectCount - paidAmount,
  };
};

// TGAT/TPAT มีเงินอุดหนุน (redeemable): วิชาที่ขอรับอุดหนุนไม่ต้องจ่าย
// order ที่จ่ายแล้วหักส่วนอุดหนุนออกจากยอดชำระ เพื่อไม่นับซ้ำกับ redeemableAmount รอบนี้
export const getTgatTpatPaymentSummary = ({ confirmations = [], subjectCount = 0, redeemableSubjectCount = 0 }) => {
  const unit = EXAM_UNIT_PRICE.tgattpat;
  const redeemableAmount = unit * redeemableSubjectCount;
  const paidAmount = _.sumBy(confirmations, (confirmation) =>
    confirmation.order_status === 'paid'
      ? confirmation.total_amount - unit * (confirmation.redeemable_subject_names || []).length
      : confirmation.total_amount - confirmation.payment_amount
  );
  return {
    paidAmount,
    redeemableAmount,
    paymentAmount: unit * subjectCount - paidAmount - redeemableAmount,
  };
};
